import { jsx as _jsx } from "react/jsx-runtime";
import { Loop as LoopIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import classNames from "classnames";
import { memo } from "react";
export const LoopVideoButton = /*#__PURE__*/ memo((param)=>{
    let { shouldLoopVideo, toggleLoopVideo } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        color: "grey",
        onClick: toggleLoopVideo,
        className: "group/loop-video-button mr-0 md:mr-2",
        size: "large",
        label: shouldLoopVideo ? "Unloop video" : "Loop video",
        children: /*#__PURE__*/ _jsx(LoopIcon, {
            className: classNames("h-6 w-6", shouldLoopVideo ? "text-teal-7 group-hover/loop-video-button:text-teal-9" : "")
        })
    });
});
LoopVideoButton.displayName = "LoopVideoButton";
